import { createFileRoute } from '@tanstack/react-router'
import { GoalCreateForm } from '../../../components/goals/GoalCreateForm'
import { ActionBar } from '../../../components/ActionBar'

export const Route = createFileRoute('/_authenticated/goals/create')({
  component: GoalCreate,
  staticData: { suppressNotifications: true },
})

function GoalCreate() {
  return (
    <>
      <ActionBar title="Create Your Goal" />
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <GoalCreateForm />
        </div>
      </div>
    </>
  )
}
